import React from 'react'

function CardIcon({ className }) {
  return (
    <svg
      className={className}
      width="82"
      height="77"
      viewBox="0 0 82 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.8374 31.9231C56.8374 31.9231 55.9263 38.167 56.8374 39.3408C57.7484 40.5145 59.8297 41.4221 62.822 42.3331C65.8143 43.2441 67.766 41.289 70.6252 44.5441C73.4845 47.7991 75.8319 56.121 77.3912 58.7243C78.9505 61.3277 80.7759 65.3607 81.182 68.3666C81.588 71.3726 80.271 73.0479 77.6676 73.4403C75.0642 73.8327 70.5024 67.4556 69.994 66.5446C69.4856 65.6336 66.9846 62.6311 66.9846 62.6311C66.9846 62.6311 65.5516 73.1707 65.5516 73.6894C65.5516 74.208 65.6813 75.9003 65.6813 75.9003H28.2141C28.2141 75.9003 31.0768 60.2904 31.8547 54.8244C32.6326 49.3584 32.2471 45.7178 35.3691 43.7661C38.491 41.8145 41.3537 42.3365 43.435 41.6848C45.5163 41.0331 46.8163 40.5145 46.9494 39.3442C47.0825 38.1739 47.079 32.7079 47.079 32.7079L56.8374 31.9231Z"
        fill="#F45E13"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M29.5652 69.7553L12.4302 74.266L13.7847 75.9174H33.3252" fill="#F45E13" />
      <path
        d="M29.5652 69.7553L12.4302 74.266L13.7847 75.9174H33.3252"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2465 72.5429C9.49541 72.0765 8.654 71.7745 7.77771 71.6569C6.90142 71.5393 6.01015 71.6087 5.16264 71.8605C2.38868 72.6692 1 75.0985 1 75.9072H12.6759C12.5315 75.2066 12.2404 74.5446 11.8216 73.9647C11.4029 73.3849 10.8661 72.9003 10.2465 72.5429Z"
        fill="#808080"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.08134 69.769C3.08134 69.769 1.57665 71.9663 1.57665 72.775C1.57665 73.5836 0.768002 74.3922 1.91785 74.7403C3.06769 75.0883 3.76715 71.0416 3.76715 70.581C3.76715 70.1204 3.08134 69.769 3.08134 69.769Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.16265 69.6564C5.16265 69.6564 3.54195 69.3152 3.08133 69.769C2.62071 70.2228 1.80865 74.2797 1.92466 74.7403C2.04067 75.2009 3.19734 75.3169 3.54195 74.8563C3.88656 74.3957 5.16265 69.6564 5.16265 69.6564Z"
        fill="#B5B5B5"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9545 73.14L14.2249 72.8296C14.0706 72.6446 13.9017 72.4723 13.7199 72.3143C13.2048 71.994 12.6611 71.7221 12.0958 71.5023C12.0958 71.5023 7.24052 69.7656 6.19987 69.0729C5.15921 68.3803 4.58258 69.7553 4.23797 70.5776C3.89336 71.3999 3.0813 74.2762 3.0813 75.0849C3.0813 75.8935 4.35056 76.2381 4.58258 75.3135C4.81459 74.3888 6.6639 71.3863 6.6639 71.3863L9.08983 72.3109C9.08983 72.3109 9.32184 72.6521 8.28118 73.3516C7.24052 74.051 5.73925 75.5455 6.19987 75.7775C6.66048 76.0095 8.04917 75.8935 8.5132 75.4363C8.97723 74.9791 11.4032 74.4127 11.4032 74.4127C11.4032 74.4127 13.6005 75.8014 14.0611 75.9174C14.3593 75.961 14.6606 75.9793 14.9619 75.972H17.7802C17.901 75.4689 17.8883 74.943 17.7435 74.4463C17.5987 73.9496 17.3267 73.4994 16.9545 73.14Z"
        fill="#B5B5B5"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.578 73.14C8.578 73.14 9.6016 71.9731 10.4307 71.8332"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.7228 63.6922C76.9582 64.0933 78.1693 64.5661 79.3497 65.1082C81.0318 65.9032 81.6528 67.8378 81.3969 70.2432C81.141 72.6487 79.4487 74.4946 76.9613 73.7849C74.474 73.0752 73.1535 71.0553 73.0648 69.4448C72.9761 67.8344 72.2562 64.2211 75.7228 63.6922Z"
        fill="#B5B5B5"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.4196 49.8907C43.5646 49.6826 39.767 46.0761 37.498 42.7733C39.7807 42.009 41.8381 42.1932 43.4349 41.6951C45.5162 41.0434 46.8162 40.5248 46.9493 39.3544C47.0823 38.1841 47.0789 32.7181 47.0789 32.7181L56.8372 31.9368C56.8372 31.9368 55.9262 38.1807 56.8372 39.3544C57.7482 40.5282 59.8296 41.4358 62.8219 42.3468C64.1321 42.7426 65.241 42.5924 66.3192 42.572C64.562 44.4895 58.5296 50.2148 49.4196 49.8907Z"
        fill="#B5B5B5"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.062 34.5497C47.7963 35.2595 48.609 35.8833 49.4845 36.4092C51.0472 37.2895 53.7222 36.5081 54.5036 35.5323C54.8857 35.0546 55.6739 34.1129 56.5167 32.9801C56.6361 31.3321 56.8579 29.8582 56.8579 29.8582L47.0995 30.6395C47.0995 30.6395 47.0791 32.6901 47.062 34.5497Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.8624 52.2688C76.8624 52.2688 71.5499 59.2634 71.0176 62.1874C70.4854 65.1115 68.8032 72.1846 68.8032 72.1846C68.8032 72.1846 63.6682 74.399 60.3927 74.4877C57.1172 74.5764 51.4498 74.0441 51.4498 74.0441C51.4498 74.0441 55.0802 64.6782 56.4962 59.9731C57.9121 55.2679 58.267 52.6236 58.267 52.6236C58.267 52.6236 66.3261 53.6848 70.9289 52.6236L77.8348 51.0302L76.8624 52.2688Z"
        fill="white"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.6098 66.9336C76.6098 66.9336 75.9615 58.7448 75.1802 58.4786C74.3988 58.2125 69.721 57.5676 68.4142 57.827C67.1074 58.0863 66.7082 58.6083 67.7659 58.8676C68.8236 59.1269 70.6252 59.3896 71.4065 59.5193C72.2887 59.7291 73.158 59.99 74.0099 60.3007C74.0099 60.3007 71.1472 60.6896 69.9769 60.6896C68.8066 60.6896 66.0736 61.8599 65.9439 62.3956C65.8671 62.7046 65.9136 63.0313 66.0736 63.3066C66.0048 63.5751 66.0119 63.8574 66.094 64.1221C66.2237 64.6441 69.3252 64.3848 70.1065 64.5145C70.8879 64.6441 72.4472 65.0194 72.4472 65.0194C72.4472 65.0194 67.8956 64.7601 67.8956 65.6711C67.8956 66.5821 69.8438 66.4491 70.6252 66.4491C71.5713 66.5534 72.4712 66.9132 73.2285 67.4897C73.6175 67.8821 73.4878 69.9225 74.6582 70.3149C75.1599 70.5119 75.6853 70.6426 76.2208 70.7038"
        fill="#B5B5B5"
      />
      <path
        d="M76.6098 66.9336C76.6098 66.9336 75.9615 58.7448 75.1802 58.4786C74.3988 58.2125 69.721 57.5676 68.4142 57.827C67.1074 58.0863 66.7082 58.6083 67.7659 58.8676C68.8236 59.1269 70.6252 59.3896 71.4065 59.5193C72.2887 59.7291 73.158 59.99 74.0099 60.3007C74.0099 60.3007 71.1472 60.6896 69.9769 60.6896C68.8066 60.6896 66.0736 61.8599 65.9439 62.3956C65.8671 62.7046 65.9136 63.0313 66.0736 63.3066C66.0048 63.5751 66.0119 63.8574 66.094 64.1221C66.2237 64.6441 69.3252 64.3848 70.1065 64.5145C70.8879 64.6441 72.4472 65.0194 72.4472 65.0194C72.4472 65.0194 67.8956 64.7601 67.8956 65.6711C67.8956 66.5821 69.8438 66.4491 70.6252 66.4491C71.5713 66.5534 72.4712 66.9132 73.2285 67.4897C73.6175 67.8821 73.4878 69.9225 74.6582 70.3149C75.1599 70.5119 75.6853 70.6426 76.2208 70.7038"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.0736 63.2931C66.0736 63.2931 71.2769 62.1193 73.8803 63.4227"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.8495 56.2676C37.8495 56.2676 35.7682 63.5523 36.1606 66.1624C36.553 68.7726 37.7199 71.7547 37.8495 72.1471C37.9792 72.5395 37.3923 75.6239 37.3923 75.6239"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.5607 15.9345C34.731 14.7642 33.5607 14.1125 33.6903 12.8125C33.82 11.5125 35.12 10.8609 35.7716 10.6015C36.4233 10.3422 36.1606 9.69054 36.2937 8.2575C36.4267 6.82447 37.9826 6.30584 39.0233 5.91687C40.0639 5.5279 39.4157 4.89327 39.9343 3.83555C40.4529 2.77783 43.319 3.05421 43.319 3.05421C43.319 3.05421 43.9673 1.88389 44.7486 1.88389C45.53 1.88389 46.0486 2.92455 47.0892 2.01354C48.1299 1.10254 49.0409 0.71357 50.4739 1.23219C50.9367 1.41638 51.4122 1.5669 51.8967 1.68258C52.3825 1.56743 52.8592 1.4169 53.323 1.23219C54.7526 0.71357 55.6636 1.10254 56.7042 2.01354C57.7449 2.92455 58.2669 1.88389 59.0483 1.88389C59.8296 1.88389 60.4779 3.05421 60.4779 3.05421C60.4779 3.05421 63.3406 2.79489 63.8626 3.83555C64.3847 4.87621 63.7295 5.52449 64.7702 5.91687C65.8109 6.30925 67.3736 6.82788 67.4998 8.2575C67.626 9.68713 67.3701 10.3388 68.0218 10.6015C68.6735 10.8643 69.9735 11.5091 70.1032 12.8125C70.2328 14.1159 69.0796 14.7642 70.2328 15.9345C71.3861 17.1048 72.5734 18.0158 71.5328 18.7972C70.4921 19.5785 69.4515 19.8378 69.5811 21.0081C69.7108 22.1785 71.0142 23.6115 69.9735 24.2598C68.9328 24.908 67.8922 24.9115 67.8922 26.0818C67.8922 27.2521 68.2811 28.9444 67.1108 29.2038C65.9405 29.4631 64.2482 29.2038 64.2482 29.9851C64.2482 30.7664 64.1185 32.1961 62.2965 31.9368C60.4745 31.6775 59.8262 31.1554 59.4338 32.1961C59.0415 33.2367 58.1339 33.9021 57.0932 33.7588C56.0525 33.6155 54.6195 33.4995 53.7085 34.2774C53.2594 34.627 52.7242 34.8486 52.1595 34.9188V34.9632C52.0708 34.9632 51.982 34.9632 51.8933 34.9632C51.8046 34.9632 51.7159 34.9632 51.6272 34.9632V34.9188C51.0628 34.8473 50.5279 34.6258 50.0781 34.2774C49.1671 33.4995 47.7375 33.6291 46.6969 33.7588C45.6562 33.8884 44.7452 33.2367 44.3562 32.1961C43.9673 31.1554 43.3156 31.6775 41.4936 31.9368C39.6716 32.1961 39.5419 30.7664 39.5419 29.9851C39.5419 29.2038 37.8359 29.4665 36.6792 29.2038C35.5226 28.941 35.8979 27.2521 35.8979 26.0818C35.8979 24.9115 34.8743 24.9115 33.8166 24.2598C32.7588 23.6081 34.0759 22.1785 34.2055 21.0081C34.3352 19.8378 33.2945 19.5785 32.2539 18.7972C31.2132 18.0158 32.3904 17.1048 33.5607 15.9345Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.9912 23.1236C43.9912 23.1236 42.5104 20.9024 41.6199 21.9396C40.7293 22.9769 41.0296 25.6416 42.2135 26.9757C43.3975 28.3098 44.7282 27.8629 44.7282 27.8629"
        fill="#B5B5B5"
      />
      <path
        d="M43.9912 23.1236C43.9912 23.1236 42.5104 20.9024 41.6199 21.9396C40.7293 22.9769 41.0296 25.6416 42.2135 26.9757C43.3975 28.3098 44.7282 27.8629 44.7282 27.8629"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.8262 23.011C59.8262 23.011 61.5561 20.9638 62.317 22.1102C63.0779 23.2566 62.4705 25.8634 61.1398 27.0406C59.8092 28.2177 58.5365 27.6308 58.5365 27.6308"
        fill="#B5B5B5"
      />
      <path
        d="M59.8262 23.011C59.8262 23.011 61.5561 20.9638 62.317 22.1102C63.0779 23.2566 62.4705 25.8634 61.1398 27.0406C59.8092 28.2177 58.5365 27.6308 58.5365 27.6308"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.9626 18.0386C58.7028 18.2585 58.3935 18.4213 58.0574 18.515C57.7212 18.6087 57.3668 18.6309 57.0203 18.58C56.3784 18.4931 55.7558 18.3103 55.1764 18.0386C55.1764 18.0386 54.0117 18.7637 53.139 18.4914C52.2663 18.2191 51.2918 17.9468 51.2918 17.9468C50.6534 18.3121 49.8916 18.442 49.1559 18.3109C47.7976 18.1273 47.4071 17.8582 47.4071 17.8582C47.4071 17.8582 46.6295 18.4914 45.8553 18.4914C45.3681 18.4898 44.8815 18.4591 44.3986 18.3996C44.1859 18.498 43.9557 18.5592 43.7194 18.58H43.0403C43.0403 18.58 42.7517 24.0133 43.7194 27.9077C44.6872 31.8021 48.4734 34.6992 50.032 35.5066C51.5906 36.314 54.2528 35.5984 55.0304 34.6929C55.808 33.7873 58.2869 31.0707 59.4448 28.7151C60.6027 26.3594 61 19.4793 61 19.0265C61 18.5737 59.438 19.1246 58.9626 18.0386Z"
        fill="#B5B5B5"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.917 23.8436C54.9284 24.1675 55.4185 24.4133 56.0117 24.3925C56.6049 24.3717 57.0766 24.0922 57.0652 23.7683C57.0539 23.4444 56.5638 23.1987 55.9706 23.2195C55.3773 23.2403 54.9056 23.5197 54.917 23.8436Z"
        fill="#263238"
      />
      <path
        d="M50.4254 23.7111C50.3968 23.3882 49.8943 23.169 49.303 23.2214C48.7117 23.2738 48.2556 23.578 48.2842 23.9008C48.3129 24.2237 48.8154 24.4429 49.4066 24.3905C49.9979 24.3381 50.454 24.0339 50.4254 23.7111Z"
        fill="#263238"
      />
      <path
        d="M52.8623 24.4884C52.8623 24.4884 52.7634 25.8532 53.2513 26.3411C53.7392 26.829 54.3226 27.2214 53.6402 27.7059C52.9578 28.1904 52.3744 28.5828 51.3986 27.7059"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.6228 29.7565C54.6228 29.7565 52.1833 30.9302 50.0371 29.3676"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.8439 21.6598C57.458 21.3713 57.006 21.1842 56.5291 21.1157C56.0522 21.0471 55.5657 21.0993 55.1143 21.2675"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.8427 21.5609C49.8427 21.5609 47.5976 20.3905 46.3284 22.2433"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.9428 40.1972L50.3306 58.9325L45.8405 40.9786"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.3549 59.8128C49.3549 60.0254 49.4179 60.2332 49.536 60.4099C49.6541 60.5867 49.8219 60.7244 50.0183 60.8058C50.2147 60.8871 50.4308 60.9084 50.6393 60.8669C50.8478 60.8255 51.0393 60.7231 51.1896 60.5728C51.3399 60.4225 51.4423 60.231 51.4838 60.0225C51.5252 59.814 51.504 59.5979 51.4226 59.4015C51.3413 59.2051 51.2035 59.0373 51.0268 58.9192C50.85 58.8011 50.6422 58.738 50.4296 58.738C50.1446 58.738 49.8712 58.8513 49.6697 59.0528C49.4681 59.2544 49.3549 59.5278 49.3549 59.8128Z"
        fill="#263238"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1771 75.914H55.5817V75.003H26.1771V75.914Z"
        fill="#808080"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.71228 55.8753H34.2431L40.2278 75.9106H10.6969L4.71228 55.8753Z"
        fill="#35363A"
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CardIcon
